module.exports = __webpack_public_path__ + "img/Leo-seul-II-584x584.fe7b292d.webp";